document.addEventListener("DOMContentLoaded", function () {
  const hamburgerButton = document.querySelector(".hamburger-button");
  const hamburgerNav = document.querySelector(".hamburger-nav");
  const hamburgerOverlay = document.querySelector(".hamburger-overlay");
  const menuItems = document.querySelectorAll(
    ".hamburger-list > li.has-submenu"
  );
  const backButtons = document.querySelectorAll(".back-button");
  const closeButton = document.querySelector(".close-button");

  function showPage(pageClass) {
    document.querySelectorAll(".menu-page").forEach((page) => {
      page.classList.remove("active");
    });
    document.querySelector(`.${pageClass}`).classList.add("active");
  }

  function openMenu() {
    hamburgerNav.classList.add("open");
    hamburgerOverlay.classList.add("active");
    document.body.classList.add("menu-open");
    showPage("main-menu");
  }

  function closeMenu() {
    hamburgerNav.classList.remove("open");
    hamburgerOverlay.classList.remove("active");
    document.body.classList.remove("menu-open");
  }

  hamburgerButton.addEventListener("click", function () {
    if (hamburgerNav.classList.contains("open")) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  // Handle overlay click
  hamburgerOverlay.addEventListener("click", function () {
    closeMenu();
  });

  // Handle close button
  closeButton.addEventListener("click", function () {
    closeMenu();
  });

  // Handle submenu navigation
  menuItems.forEach((item) => {
    item.addEventListener("click", function () {
      const page = this.getAttribute("data-page");
      showPage(`${page}-menu`);
    });
  });

  // Handle back buttons
  backButtons.forEach((button) => {
    button.addEventListener("click", function () {
      showPage("main-menu");
    });
  });

  // Carousel functionality
  function initCarousels() {
    const carousels = document.querySelectorAll(".hamburger-product-carousel");

    carousels.forEach((carousel) => {
      const track = carousel.querySelector(".carousel-track");
      const prevBtn = carousel.querySelector(".carousel-btn-prev");
      const nextBtn = carousel.querySelector(".carousel-btn-next");
      const items = carousel.querySelectorAll(".carousel-item");

      if (!track || !prevBtn || !nextBtn || items.length === 0) return;

      let currentIndex = 0;
      let startX = 0;
      let isDragging = false;
      let currentTranslate = 0;
      let prevTranslate = 0;

      function getItemWidth() {
        return items[0].offsetWidth + 16; // item width + gap
      }

      function updateCarousel() {
        const itemWidth = getItemWidth();
        const offset = -currentIndex * itemWidth;
        track.style.transform = `translateX(${offset}px)`;
        currentTranslate = offset;
        prevTranslate = offset;

        // Update button states
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex >= items.length - 1;
      }

      // Previous button
      prevBtn.addEventListener("click", () => {
        if (currentIndex > 0) {
          currentIndex--;
          updateCarousel();
        }
      });

      // Next button
      nextBtn.addEventListener("click", () => {
        if (currentIndex < items.length - 1) {
          currentIndex++;
          updateCarousel();
        }
      });

      // Touch/swipe support
      track.addEventListener("touchstart", (e) => {
        isDragging = true;
        startX = e.touches[0].clientX;
        track.style.transition = "none";
      });

      track.addEventListener("touchmove", (e) => {
        if (!isDragging) return;
        const currentX = e.touches[0].clientX;
        const diff = currentX - startX;
        currentTranslate = prevTranslate + diff;
        track.style.transform = `translateX(${currentTranslate}px)`;
      });

      track.addEventListener("touchend", () => {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = "transform 0.3s ease-in-out";

        const movedBy = currentTranslate - prevTranslate;
        const itemWidth = getItemWidth();

        // If moved more than 30% of item width, change slide
        if (movedBy < -itemWidth * 0.3 && currentIndex < items.length - 1) {
          currentIndex++;
        } else if (movedBy > itemWidth * 0.3 && currentIndex > 0) {
          currentIndex--;
        }

        updateCarousel();
      });

      // Mouse drag support (optional)
      track.addEventListener("mousedown", (e) => {
        isDragging = true;
        startX = e.clientX;
        track.style.transition = "none";
        track.style.cursor = "grabbing";
      });

      track.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const currentX = e.clientX;
        const diff = currentX - startX;
        currentTranslate = prevTranslate + diff;
        track.style.transform = `translateX(${currentTranslate}px)`;
      });

      track.addEventListener("mouseup", () => {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = "transform 0.3s ease-in-out";
        track.style.cursor = "grab";

        const movedBy = currentTranslate - prevTranslate;
        const itemWidth = getItemWidth();

        if (movedBy < -itemWidth * 0.3 && currentIndex < items.length - 1) {
          currentIndex++;
        } else if (movedBy > itemWidth * 0.3 && currentIndex > 0) {
          currentIndex--;
        }

        updateCarousel();
      });

      track.addEventListener("mouseleave", () => {
        if (isDragging) {
          isDragging = false;
          track.style.transition = "transform 0.3s ease-in-out";
          track.style.cursor = "grab";
          updateCarousel();
        }
      });

      // Initialize
      track.style.cursor = "grab";
      updateCarousel();

      // Update on window resize
      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          updateCarousel();
        }, 250);
      });
    });
  }

  // Initialize carousels when menu opens
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.target.classList.contains("hamburger-nav") &&
        mutation.target.classList.contains("open")
      ) {
        setTimeout(initCarousels, 100); // Small delay to ensure DOM is ready
      }
    });
  });

  if (hamburgerNav) {
    observer.observe(hamburgerNav, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
});
